export const addElementToStackArray = (arr, element, limit = 5) => {
  // Tìm vị trí phần tử nếu đã tồn tại
  const index = arr.findIndex(e => e.id === element.id);

  if (index !== -1) {
    // Xóa phần tử cũ
    arr.splice(index, 1);
  }

  // Thêm phần tử vào đầu mảng
  arr.unshift(element);

  // Giữ giới hạn
  if (arr.length > limit) {
    arr.pop();
  }

  return arr;
};